var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cdb-rdb" },
    [
      _c(
        "v-row",
        { staticClass: "flex-column content", attrs: { align: "start" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              staticClass: "formulario",
              attrs: { "lazy-validation": "" }
            },
            [
              _c(
                "v-row",
                { staticClass: "flex-column line", attrs: { align: "start" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex flex-column align-start py-0" },
                    [
                      _c("span", { staticClass: "text-filelds" }, [
                        _vm._v("Nome e Sobrenome")
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "column" },
                    [
                      _c("v-text-field", {
                        staticClass: "input",
                        attrs: {
                          placeholder: "Roberto Silva",
                          rules: [
                            function(v) {
                              return !!v || "Nome requerido"
                            }
                          ],
                          color: "secondary",
                          required: "",
                          dense: "",
                          outlined: "",
                          rounded: ""
                        },
                        model: {
                          value: _vm.user.name,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "name", $$v)
                          },
                          expression: "user.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "flex-column line", attrs: { align: "start" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex flex-column align-start py-0" },
                    [
                      _c("span", { staticClass: "text-filelds" }, [
                        _vm._v("E-mail")
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "column" },
                    [
                      _c("v-text-field", {
                        staticClass: "input",
                        attrs: {
                          placeholder: "curtis.weave@example.com",
                          rules: [
                            function(v) {
                              return !!v || "E-mail requerido"
                            }
                          ],
                          color: "secondary",
                          required: "",
                          dense: "",
                          outlined: "",
                          rounded: ""
                        },
                        model: {
                          value: _vm.user.email,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "email", $$v)
                          },
                          expression: "user.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "flex-column line", attrs: { align: "start" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex flex-column align-start py-0" },
                    [
                      _c("span", { staticClass: "text-filelds" }, [
                        _vm._v("Telefone")
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "column" },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["(##)####-####", "(##)#####-####"],
                            expression: "['(##)####-####', '(##)#####-####']"
                          }
                        ],
                        staticClass: "input",
                        attrs: {
                          placeholder: "(22) 5555-9090",
                          rules: [
                            function(v) {
                              return !!v || "Telefone requerido"
                            }
                          ],
                          color: "secondary",
                          required: "",
                          dense: "",
                          outlined: "",
                          rounded: ""
                        },
                        model: {
                          value: _vm.user.phoneNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "phoneNumber", $$v)
                          },
                          expression: "user.phoneNumber"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "flex-column line", attrs: { align: "start" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex flex-column align-left py-0" },
                    [
                      _c("span", { staticClass: "text-filelds" }, [
                        _vm._v("Tipo de Plano")
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "column" },
                    [
                      _c("v-select", {
                        staticClass: "select",
                        attrs: {
                          items: _vm.items,
                          "item-text": "name",
                          "menu-props": { bottom: true, offsetY: true },
                          placeholder: "Selecione",
                          color: "secondary",
                          required: "",
                          outlined: "",
                          rounded: "",
                          dense: "",
                          height: "0",
                          "append-icon": ""
                        },
                        model: {
                          value: _vm.user.tipoPlano,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "tipoPlano", $$v)
                          },
                          expression: "user.tipoPlano"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }